// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__2vegf","header":"style_header__26f0R","tabs":"style_tabs__1nnie","tab":"style_tab__RRtJV"};